import { useApi } from '@omnipresentgroup/api';
import { useMutation } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useRequestLiabilityShield = () => {
  const { POST } = useApi();
  return useMutation({
    mutationFn: (payload: { contractorId?: string }) => {
      return POST({
        path: `${API_BASE}/${API_PATH}/request-liability-shield-coverage`,
        body: payload,
      });
    },
  });
};
